import { Injectable } from '@angular/core';
import { NavigationElement } from './navigation-element';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class NavigationElementService {
	
	navigationElementsObservable = new BehaviorSubject<Array<NavigationElement>>([]);
	clearNavigationElementsObservable = new BehaviorSubject<boolean>(false);

	/**
	 * changeNavigationElements
	 * publish new navigationElements
	 * @param navigationElements 
	 */
	changeNavigationElements(navigationElements: Array<NavigationElement>): void {
		this.navigationElementsObservable.next(navigationElements);
	}

	/**
	 * clearNavigationElements
	 * publish wether or not clear navigation elements
	 * @param navigationElements 
	 */
	clearNavigationElements(shouldClear: boolean): void {
		this.clearNavigationElementsObservable.next(shouldClear);
	}

}
